export default __webpack_public_path__ + "static/media/learnmore-pig.d35315e1.svg";